export const YARDI_API_URL = '/api/v3/payments/yardi';

export const API_V2 = '/api/v2/user';

export const API_V1 = '/api/v1/users';